import { render, staticRenderFns } from "./relationTask.vue?vue&type=template&id=58c317d1&scoped=true&"
import script from "./relationTask.vue?vue&type=script&lang=js&"
export * from "./relationTask.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58c317d1",
  null
  
)

export default component.exports